module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_Frame05-ca6460ecd4a069c9ea575e978b382e75.png";